import { ABOUT_YOU_CONFIG } from "ui/pages/TemplatePreview/constants.js";
import { validURL } from "utils/validations";
import {
  ABOUT_YOU_MESSAGES,
  ABOUT_YOU_FIELD_KEYS,
  ABOUT_YOU_ERROR_KEYS,
} from "../../../sidebar.constant";

export const useCreateAboutYouHandlers = ({
  state,
  setField,
  setErrorMessage,
  enableError,
  hiddenFields = [],
}) => {
  const handleDisplayImageUpload = (firebaseUrl) => {
    setField(ABOUT_YOU_FIELD_KEYS.DISPLAY_IMAGE, firebaseUrl);
  };

  const handleDisplayNameChange = (e) => {
    const inputVal = e.target.value || "";
    setField(ABOUT_YOU_FIELD_KEYS.DISPLAY_NAME, inputVal);

    if (inputVal.length >= ABOUT_YOU_CONFIG.MAX_NAME_LENGTH) {
      enableError(ABOUT_YOU_ERROR_KEYS.DISPLAY_NAME);
      setErrorMessage(
        ABOUT_YOU_ERROR_KEYS.DISPLAY_NAME,
        `${ABOUT_YOU_MESSAGES.MAX_FIELD_LENGTH} ${ABOUT_YOU_CONFIG.MAX_NAME_LENGTH} ${ABOUT_YOU_MESSAGES.REACHED}`
      );
      return;
    }
    if (inputVal?.length === ABOUT_YOU_CONFIG.DEFAULT_LENGTH) {
      setErrorMessage(
        ABOUT_YOU_ERROR_KEYS.DISPLAY_NAME,
        ABOUT_YOU_MESSAGES.NAME_REQUIRED
      );
      return;
    }
    if (inputVal?.length < ABOUT_YOU_CONFIG.MIN_NAME_LENGTH) {
      setErrorMessage(
        ABOUT_YOU_ERROR_KEYS.DISPLAY_NAME,
        `${ABOUT_YOU_MESSAGES.FULL_NAME_MIN} ${ABOUT_YOU_CONFIG.MIN_NAME_LENGTH} ${ABOUT_YOU_MESSAGES.CHARACTERS} (${ABOUT_YOU_MESSAGES.CURRENTLY} ${inputVal.length})`
      );
      return;
    }

    setErrorMessage(ABOUT_YOU_ERROR_KEYS.DISPLAY_NAME, null);
  };

  const handleDisplayNameBlur = () => {
    enableError(ABOUT_YOU_ERROR_KEYS.DISPLAY_NAME);
    if (state?.display_name) {
      setField(ABOUT_YOU_FIELD_KEYS.DISPLAY_NAME, state?.display_name?.trim());
    }
  };

  const handleShortBioChange = (e) => {
    const inputVal = e.target.value || "";
    setField(ABOUT_YOU_FIELD_KEYS.SOCIAL_INFO_WEBSITE_DESC, inputVal);
    setErrorMessage(
      ABOUT_YOU_ERROR_KEYS.WEBSITE_DESC,
      (() => {
        if (inputVal?.length === ABOUT_YOU_CONFIG.DEFAULT_LENGTH) return null;
        if (inputVal?.length < ABOUT_YOU_CONFIG.MIN_NAME_LENGTH)
          return `${ABOUT_YOU_MESSAGES.SHORT_BIO_MIN} ${ABOUT_YOU_CONFIG.MIN_NAME_LENGTH} ${ABOUT_YOU_MESSAGES.CHARACTERS}`;
        if (inputVal?.length >= ABOUT_YOU_CONFIG.MAX_DESC_LENGTH) {
          enableError(ABOUT_YOU_ERROR_KEYS.WEBSITE_DESC);
          return `${ABOUT_YOU_MESSAGES.MAX_FIELD_LENGTH} ${ABOUT_YOU_CONFIG.MAX_DESC_LENGTH} ${ABOUT_YOU_MESSAGES.REACHED}`;
        }
        return null;
      })()
    );
  };

  const handleShortBioBlur = () => {
    enableError(ABOUT_YOU_ERROR_KEYS.WEBSITE_DESC);
    if (state?.social_info?.website_desc) {
      setField(
        ABOUT_YOU_FIELD_KEYS.SOCIAL_INFO_WEBSITE_DESC,
        state?.social_info?.website_desc?.trim()
      );
    }
  };

  const handleSectionTitleChange = (e) => {
    setField(
      ABOUT_YOU_FIELD_KEYS.SOCIAL_INFO_ABOUT_SECTION_TITLE,
      e.target.value
    );
  };

  const handleNavbarTitleChange = (e) => {
    const inputVal = e.target.value || "";
    setField(ABOUT_YOU_FIELD_KEYS.LEAD_KEYS_ABOUT_TITLE, inputVal);

    if (inputVal.length >= ABOUT_YOU_CONFIG.MAX_NAVBAR_TITLE_LENGTH) {
      enableError(ABOUT_YOU_ERROR_KEYS.ABOUT_TITLE);
      setErrorMessage(
        ABOUT_YOU_ERROR_KEYS.ABOUT_TITLE,
        `${ABOUT_YOU_MESSAGES.NAVBAR_TITLE_MAX} ${ABOUT_YOU_CONFIG.MAX_NAVBAR_TITLE_LENGTH} ${ABOUT_YOU_MESSAGES.CHARACTERS}`
      );
      return;
    }
    setErrorMessage(ABOUT_YOU_ERROR_KEYS.ABOUT_TITLE, null);
  };

  const handleNavbarTitleBlur = () => {
    enableError(ABOUT_YOU_ERROR_KEYS.ABOUT_TITLE);
    const currentValue =
      state?.lead_keys?.about_title ||
      state?.custom_headings?.about_title ||
      state?.navbar_titles?.about_title ||
      "";
    if (currentValue) {
      setField(ABOUT_YOU_FIELD_KEYS.LEAD_KEYS_ABOUT_TITLE, currentValue.trim());
    }
  };

  const handleAboutSectionNavbarTitleChange = (e) => {
    setField(
      ABOUT_YOU_FIELD_KEYS.LEAD_KEYS_ABOUT_SECTION_NAVBAR_TITLE,
      e.target.value
    );
  };

  const handleBioTextChange = (t) => {
    setField(ABOUT_YOU_FIELD_KEYS.BIO_TEXT, t);
  };

  const handleExpandCheckbox = (e) => {
    setField(ABOUT_YOU_FIELD_KEYS.LEAD_KEYS_EXPAND_HOST_DESC, e.target.checked);
  };

  const handleExperienceYearsCountChange = (e) => {
    setField(
      ABOUT_YOU_FIELD_KEYS.SOCIAL_INFO_EXPERIENCE_YEARS_COUNT,
      e.target.value || ""
    );
  };

  const handleExperienceYearsLabelChange = (e) => {
    setField(
      ABOUT_YOU_FIELD_KEYS.SOCIAL_INFO_EXPERIENCE_YEARS_LABEL,
      e.target.value || ""
    );
  };

  const handleVideoChange = (e) => {
    const inputVal = (e.target.value || "").trim();
    setField(ABOUT_YOU_FIELD_KEYS.SOCIAL_INFO_VIDEO, inputVal);
    setErrorMessage(
      ABOUT_YOU_ERROR_KEYS.VIDEO,
      validURL(inputVal) || inputVal.length === ABOUT_YOU_CONFIG.DEFAULT_LENGTH
        ? null
        : ABOUT_YOU_MESSAGES.INVALID_VIDEO_URL
    );
  };

  const handleVideoBlur = () => {
    enableError(ABOUT_YOU_ERROR_KEYS.VIDEO);
    if (state?.social_info?.video) {
      setField(
        ABOUT_YOU_FIELD_KEYS.SOCIAL_INFO_VIDEO,
        (state?.social_info?.video || "").trim()
      );
    }
  };

  const showSectionTitle = (key) => {
    return !hiddenFields.includes(key);
  };

  return {
    handleDisplayImageUpload,
    handleDisplayNameChange,
    handleDisplayNameBlur,
    handleShortBioChange,
    handleShortBioBlur,
    handleSectionTitleChange,
    handleNavbarTitleChange,
    handleNavbarTitleBlur,
    handleAboutSectionNavbarTitleChange,
    handleBioTextChange,
    handleExpandCheckbox,
    handleExperienceYearsCountChange,
    handleExperienceYearsLabelChange,
    handleVideoChange,
    handleVideoBlur,
    showSectionTitle,
  };
};
